export default __webpack_public_path__ + "static/media/add-plus-icon.02b74869.svg";